import Vue from "vue"
import { Mutations, Actions } from "./types"
import { ArticleState, IMutations, IActions } from "./articleType"

function _init(): ArticleState {
  return {
    id: null,
    title: "",
    rssTitle: "",
    rssCategory: "",
    overview: "",
    writer: null,
    editor: null,
    curator: null,
    eyecatch: { url: "", filename: "" },
    thumbnail: { url: "", filename: "" },
    editorData: "",
    relatedArticles: [],
    status: "編集中",
    writerDisplayEnabled: true,
    articleType: null,
    isAdvertisementEnabled: false,
    inlineAdvertisementType: "on",
    isNoIndex: false,
    isNoFollow: false,
    showRss: false,
    canonicalUrl: null,
    publishedAt: null,
    endOfPublishedAt: null,
    rssPublishedAt: null,
    analyticsGroup: null,
    enableDisplayUpdatedAt: true,
    categories: [],
    subCategories: [],
    updatedAt: null,
    mainCategoryId: null,
    mainSubCategory: null,
    overlayAppAffiliateTemplate: null,
    bannerType: null,
  }
}

const state = _init()

const mutations: Mutations<ArticleState, IMutations> = {
  initArticle(_state) {
    const newArticleState = _init()
    Object.entries(newArticleState).forEach(([k, v]) => {
      Vue.set(_state, k, v)
    })
  },
  updateArticle(_state, payload) {
    Object.entries(payload).forEach(([k, v]) => {
      Vue.set(_state, k, v)
    })
  },
  addCategory(_state, payload) {
    _state.categories.push(payload.category)
    _state.categories.sort((a, b) => {
      if (a.priority < b.priority) {
        return 1
      } else if (a.priority === b.priority) {
        return 0
      } else {
        return -1
      }
    })
  },
  removeCategory(_state, payload) {
    _state.categories = _state.categories.filter(
      (category) => category.id !== payload.category.id
    )
  },
  updateMainCategoryId(_state, payload) {
    _state.mainCategoryId = payload.mainCategoryId
  },
  updateMainSubCategory(_state, payload) {
    _state.mainSubCategory = payload.mainSubCategory
  },
  updateSubCategories(_state, payload) {
    _state.subCategories = payload.subCategories
  },
}
const actions: Actions<ArticleState, IActions, any, IMutations, any, any> = {
  initArticle(context) {
    context.commit("initArticle")
  },
  updateArticle(context, payload) {
    context.commit("updateArticle", payload)
  },
  addCategory(context, payload) {
    context.commit("addCategory", payload)
  },
  removeCategory(context, payload) {
    context.commit("removeCategory", payload)
  },
  updateMainCategoryId(context, payload) {
    context.commit("updateMainCategoryId", payload)
  },
  updateMainSubCategory(context, payload) {
    context.commit("updateMainSubCategory", payload)
  },
  updateSubCategories(context, payload) {
    context.commit("updateSubCategories", payload)
  },
}

export const article = {
  namespaced: true,
  state,
  mutations,
  actions,
}
